var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGripLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 13.9258H0.75C0.328125 13.9258 0 14.3008 0 14.6758V16.1758C0 16.5977 0.328125 16.9258 0.75 16.9258H23.25C23.625 16.9258 24 16.5977 24 16.1758V14.6758C24 14.3008 23.625 13.9258 23.25 13.9258ZM23.25 7.92578H0.75C0.328125 7.92578 0 8.30078 0 8.67578V10.1758C0 10.5977 0.328125 10.9258 0.75 10.9258H23.25C23.625 10.9258 24 10.5977 24 10.1758V8.67578C24 8.30078 23.625 7.92578 23.25 7.92578Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripLines);
export default __webpack_public_path__ + "static/media/grip-lines.c7dc2c616ad560be122dcb7a3ccb261f.svg";
export { ForwardRef as ReactComponent };